import { mergeStyles } from "@fluentui/react/lib/Styling";
import { commonStyles, designTokens, sectionStyles, } from "./shared.styles";
const requirementColors = {
    incident: { background: "#fde7e9", text: "#a4262c" },
    support: { background: "#fff4ce", text: "#8a4b08" },
    optional: {
        background: "#edebe9",
        text: designTokens.colors.textSecondary,
    },
};
export const callTypeSectionStyles = {
    sectionHeader: sectionStyles.header,
    sectionHeaderComplete: sectionStyles.headerComplete,
    // Component-specific styles
    sectionContainer: commonStyles.sectionContainer,
    description: commonStyles.description,
    stepNumber: mergeStyles({
        alignItems: "center",
        backgroundColor: "#107c10",
        borderRadius: "50%",
        color: designTokens.colors.white,
        display: "inline-flex",
        fontSize: "10px",
        fontWeight: 600,
        height: "16px",
        justifyContent: "center",
        width: "16px",
    }),
    instruction: mergeStyles({
        color: designTokens.colors.textSecondary,
        fontSize: designTokens.fontSize.sm,
        marginBottom: designTokens.spacing.lg,
    }),
    tilesContainer: mergeStyles({
        display: "grid",
        gap: designTokens.spacing.lg,
        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        "@media (max-width: 1000px)": {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        },
        "@media (max-width: 600px)": {
            gridTemplateColumns: "1fr",
        },
    }),
    tile: (isSelected) => mergeStyles({
        backgroundColor: isSelected
            ? designTokens.colors.primaryLight
            : designTokens.colors.white,
        border: isSelected
            ? `2px solid ${designTokens.colors.primary}`
            : `1px solid ${designTokens.colors.border}`,
        borderRadius: "8px",
        boxSizing: "border-box",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        minHeight: "150px",
        padding: `${designTokens.spacing.lg} ${designTokens.spacing.xl}`,
        position: "relative",
        transition: designTokens.transitions.default,
        ":focus-within": {
            outline: `2px solid ${designTokens.colors.primary}`,
            outlineOffset: "2px",
        },
        ":hover": {
            borderColor: designTokens.colors.primary,
            boxShadow: designTokens.shadows.hover,
        },
    }),
    radio: mergeStyles({
        accentColor: designTokens.colors.primary,
        cursor: "pointer",
        height: "20px",
        margin: 0,
        position: "absolute",
        right: designTokens.spacing.md,
        top: designTokens.spacing.md,
        width: "20px",
    }),
    tileHeader: mergeStyles({
        alignItems: "center",
        display: "flex",
        gap: designTokens.spacing.md,
        paddingRight: designTokens.spacing.xxl,
    }),
    tileIcon: (iconColor) => mergeStyles({
        color: iconColor,
        fontSize: "22px",
    }),
    tileTitle: mergeStyles({
        color: designTokens.colors.text,
        fontSize: "18px",
        fontWeight: 600,
    }),
    tileDescription: mergeStyles({
        color: designTokens.colors.textSecondary,
        fontSize: designTokens.fontSize.sm,
        lineHeight: "20px",
        marginTop: designTokens.spacing.sm,
    }),
    requirements: mergeStyles({
        display: "flex",
        flexWrap: "wrap",
        gap: designTokens.spacing.sm,
        marginTop: "auto",
        paddingTop: designTokens.spacing.md,
    }),
    requirementBadge: (kind) => mergeStyles({
        backgroundColor: requirementColors[kind].background,
        borderRadius: "12px",
        color: requirementColors[kind].text,
        fontSize: designTokens.fontSize.xs,
        fontWeight: 600,
        padding: "3px 10px",
    }),
    legend: mergeStyles({
        alignItems: "center",
        color: designTokens.colors.textSecondary,
        display: "flex",
        flexWrap: "wrap",
        fontSize: designTokens.fontSize.xs,
        gap: designTokens.spacing.lg,
        marginTop: designTokens.spacing.md,
    }),
    legendItem: mergeStyles({
        alignItems: "center",
        display: "inline-flex",
        gap: designTokens.spacing.xs,
    }),
    legendSwatch: (kind) => mergeStyles({
        backgroundColor: requirementColors[kind].background,
        borderRadius: "3px",
        height: "12px",
        width: "12px",
    }),
    footnote: mergeStyles({
        color: designTokens.colors.textSecondary,
    }),
    // Container with opacity for locked state
    mainContainer: (isUnlocked) => mergeStyles({
        marginTop: designTokens.spacing.xxl,
        opacity: isUnlocked ? 1 : 0.6,
    }),
    // Inner content container
    contentContainer: mergeStyles({
        marginTop: designTokens.spacing.md,
    }),
    // Header text style
    headerText: mergeStyles({
        color: designTokens.colors.text,
        fontSize: designTokens.fontSize.sm,
        fontWeight: 600,
    }),
    // Dynamic cursor style for interactive elements
    interactiveStyle: (isUnlocked) => mergeStyles({
        cursor: isUnlocked ? "pointer" : "not-allowed",
        pointerEvents: isUnlocked ? "auto" : "none",
    }),
};
